import RemoveIcon from "@mui/icons-material/CloseRounded";
import EditIcon from "@mui/icons-material/EditOutlined";
import { IconButton, Stack, Tooltip, Typography } from "@mui/material";
import { convertISODate } from "@entrilia/shared/utilities/dateUtils";
import type { UserAccessMatrixRow } from "./userAccessMatrixModel";

export interface GridActions {
  onEditUsers: (rows: UserAccessMatrixRow[]) => void;
  onRemoveUsers: (rows: UserAccessMatrixRow[]) => void;
}

interface ActionsCellProps {
  row: UserAccessMatrixRow;
  actions: GridActions;
  hasPermissionsToManage: boolean;
}

export const ActionsCell = ({ row, actions, hasPermissionsToManage }: ActionsCellProps) => {
  if (!hasPermissionsToManage) {
    return null;
  }

  return (
    <>
      <Tooltip title="Edit" arrow>
        <IconButton onClick={() => actions.onEditUsers([row])}>
          <EditIcon />
        </IconButton>
      </Tooltip>
      <Tooltip title="Remove" arrow>
        <IconButton color="error" onClick={() => actions.onRemoveUsers([row])}>
          <RemoveIcon />
        </IconButton>
      </Tooltip>
    </>
  );
};

export const RegistrationStatusCell = ({ row }: { row: UserAccessMatrixRow }) => {
  return (
    <Stack spacing={0.5} sx={{ width: "100%" }}>
      <Typography>{row.registrationDate ? "Registered" : "Not Registered"}</Typography>
      <Typography variant="caption" color="textSecondary">
        {convertISODate(row.registrationDate)}
      </Typography>
    </Stack>
  );
};
